module.exports = __webpack_public_path__ + "img/whatsapp.e12b3b2d.svg";